import { SchedulingCheckCtrl } from './scheduling-check.controller';

export const SchedulingCheckComponent = {
  controller: SchedulingCheckCtrl,
  bindings: {
    currentSchool: '<',
    studentSupports: '<',
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./scheduling-check.html'),
};
